// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"3ca3d318","453":"797c7366","545":"625bb74e","558":"cd7667ab","726":"9ecb843d"}[chunkId] + ".chunk.css";
};